<template>
  <v-container fluid fill-height class="ma-0 pa-0" style="background: #4d4d4d">
    <v-row no-gutters>
      <v-tooltip top z-index="1000">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            :large="btnLarge"
            :small="btnSmall"
            :class="btnSmall ? 'mt-2' : ''"
            v-on="on"
            @click="selectAll"
          >
            <v-icon color="white">{{ selectIcon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("SelectAll") }}</span>
      </v-tooltip>

      <div>
        <v-icon :small="btnSmall" color="blue-grey lighten-3"
          >mdi-drag-vertical-variant</v-icon
        >
        <v-tooltip top z-index="1000">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              :large="btnLarge"
              :small="btnSmall"
              :class="btnSmall ? 'mt-2' : ''"
              v-on="on"
              @click="refreshDocuments"
            >
              <v-icon color="light-blue lighten-3">mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Refresh") }}</span>
        </v-tooltip>
      </div>

      <div>
        <v-icon :small="btnSmall" color="blue-grey lighten-3"
          >mdi-drag-vertical-variant</v-icon
        >
        <v-tooltip top z-index="1000">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              :large="btnLarge"
              :small="btnSmall"
              :class="btnSmall ? 'mt-2' : ''"
              v-on="on"
              @click.prevent="groupBy"
            >
              <v-icon color="light-blue lighten-3"
                >mdi-file-tree-outline</v-icon
              >
            </v-btn>
          </template>
          <span>{{ $t("ToGroup") }}</span>
        </v-tooltip>
      </div>

      <v-tooltip top z-index="1000">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            :large="btnLarge"
            :small="btnSmall"
            :class="btnSmall ? 'mt-2' : ''"
            v-on="on"
            @click.prevent="filter"
          >
            <v-icon color="light-blue lighten-3">mdi-filter</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("ToFilter") }}</span>
      </v-tooltip>

      <v-tooltip top z-index="1000">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            :large="btnLarge"
            :small="btnSmall"
            :class="btnSmall ? 'mt-2' : ''"
            v-on="on"
            @click.prevent="sort"
          >
            <v-icon color="light-blue lighten-3"
              >mdi-sort-alphabetical-ascending</v-icon
            >
          </v-btn>
        </template>
        <span>{{ $t("Sort") }}</span>
      </v-tooltip>

      <div v-if="!isReadonlyUser">
        <v-icon :small="btnSmall" color="blue-grey lighten-3"
          >mdi-drag-vertical-variant</v-icon
        >
        <v-tooltip top z-index="1000">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              :large="btnLarge"
              :small="btnSmall"
              :class="btnSmall ? 'mt-2' : ''"
              v-on="on"
              @click.prevent="validate"
            >
              <v-icon color="success">mdi-check-bold</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Validate") }}</span>
        </v-tooltip>

        <v-tooltip top z-index="1000">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              :large="btnLarge"
              :small="btnSmall"
              :class="btnSmall ? 'mt-2' : ''"
              v-on="on"
              @click.prevent="refuse"
            >
              <v-icon color="red">mdi-close-thick</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Refuse") }}</span>
        </v-tooltip>

        <v-icon :small="btnSmall" color="blue-grey lighten-3"
          >mdi-drag-vertical-variant</v-icon
        >

        <v-menu bottom offset-y>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip top z-index="1000">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  icon
                  :large="btnLarge"
                  :small="btnSmall"
                  :class="btnSmall ? 'mt-2' : ''"
                  v-bind="attrs"
                  v-on="{ ...tooltip, ...menu }"
                >
                  <v-icon color="teal lighten-4">mdi-share-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Distribute") }}</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item-group>
              <v-list-item @click="internalDistributeSelected">
                <v-list-item-icon>
                  <v-icon>mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $t("DistributeInternal")
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="externalDistributeSelected">
                <v-list-item-icon>
                  <v-icon>mdi-email-multiple-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $t("DistributeExternal")
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="generateLinkSelected">
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $t("CopyLinkToClipboard")
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>

      <v-menu bottom offset-y>
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip top z-index="1000">
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                icon
                :large="btnLarge"
                :small="btnSmall"
                :class="btnSmall ? 'mt-2' : ''"
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
                @click="loadPluginList()"
              >
                <v-icon color="teal lighten-4">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Tools") }}</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item-group>
            <v-list-item @click="exportSelected" v-if="!isReadonlyUser">
              <v-list-item-icon>
                <v-icon>mdi-export</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("Export") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="deleteSelected"
              :class="{ 'disabled-item': !deleteAvailable() }"
            >
              <v-list-item-icon>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-delete</v-icon>
                  </template>
                  <span v-if="!deleteAvailable()">{{
                    $t("Unauthorized")
                  }}</span>
                </v-tooltip>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("Delete") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="editSelected"
              :class="{ 'disabled-item': !editAvailable() }"
            >
              <v-list-item-icon>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-pencil</v-icon>
                  </template>
                  <span v-if="!editAvailable()">{{ $t("Unauthorized") }}</span>
                </v-tooltip>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("Edit") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="downloadSelected">
              <v-list-item-icon>
                <v-icon>mdi-download</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("Download") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-for="plugin in pluginList"
              v-bind:key="plugin.id"
              @click="loadPlugin(plugin)"
            >
              <v-list-item-icon>
                <v-icon>{{ plugin.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ plugin.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
      <v-spacer />
      <div class="ma-2 text-right">
        <p class="white--text py-0 my-0 text-caption text-lg-body-1">
          {{ totalAndFiltered }}
        </p>
        <p class="white--text py-0 my-0 text-caption text-lg-body-1">
          {{ selectedDocuments.length }} {{ $t("Selected").toLowerCase() }}
        </p>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import PluginService from "@/services/PluginService";
import Plugin from "@/ecm/models/plugin/Plugin";
import AccountType from "@/ecm/variables/AccountType";
import SearchType from "@/ecm/variables/SearchType";
import Utils from "@/ecm/common/Utils";

export default {
  name: "DocumentListToolbar",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    totalResults: {
      type: undefined,
      required: true,
    },
    filteredResults: {
      type: Number,
      default: 0,
    },
    selectedDocuments: {
      type: Array,
      default: () => [],
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isSelected: false,
      selectIcon: "mdi-checkbox-blank-outline",
      pluginList: [],
    };
  },
  computed: {
    totalAndFiltered() {
      if (this.filteredResults > 0) {
        return `${this.totalResults} ${this.$t("Results")} (${
          this.filteredResults
        } ${this.$t("Filtered").toLowerCase()})`;
      } else {
        return `${this.totalResults} ${this.$t("Results")}`;
      }
    },
    generatedLink() {
      return `${window.location.origin}/#/search/${
        SearchType.DocumentIDs
      }/${this.selectedDocuments.join()}`;
    },
    btnLarge() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    btnSmall() {
      return this.$vuetify.breakpoint.width <= 1024;
    },
    isReadonlyUser() {
      return (
        this.$store.getters["account/user"].AccountType == AccountType.Readonly
      );
    },
  },
  methods: {
    editAvailable() {
      return !this.isReadonlyUser && this.canEdit;
    },
    deleteAvailable() {
      return !this.isReadonlyUser && this.canDelete;
    },
    selectAll() {
      this.isSelected = !this.isSelected;
      this.selectIcon = this.isSelected
        ? "mdi-check-box-outline"
        : "mdi-checkbox-blank-outline";

      this.$emit("on-select-all-change", this.isSelected);
    },
    unmarkSelectAll() {
      this.isSelected = false;
      this.selectIcon = "mdi-checkbox-blank-outline";
    },
    refreshDocuments() {
      this.$emit("on-refresh-click");
      if (this.isSelected) {
        this.selectAll();
      }
    },
    validate() {
      this.$emit("on-validate-click");
    },
    refuse() {
      this.$emit("on-refuse-click");
    },
    filter() {
      this.$emit("on-filter-click");
    },
    groupBy() {
      this.$emit("on-groupBy-click");
    },
    sort() {
      this.$emit("on-sort-click");
    },
    exportSelected() {
      this.$emit("on-export-selected-click");
    },
    deleteSelected() {
      if (!this.deleteAvailable()) return;
        this.$emit("on-delete-selected-click");
    },
    editSelected() {
      if (!this.editAvailable()) return;
       this.$emit("on-edit-selected-click");
    },
    downloadSelected() {
      this.$emit("on-download-selected-click");
    },
    internalDistributeSelected() {
      this.$emit("on-internal-distribute-selected-click");
    },
    externalDistributeSelected() {
      this.$emit("on-external-distribute-selected-click");
    },
    generateLinkSelected() {
      navigator.clipboard.writeText(this.generatedLink);
      Utils.toast.success(this.$t("LinkCopiedToClipboard"));
    },
    loadPlugin(plugin) {
      const objectIDs = this.selectedDocuments;
      this.$emit("on-load-plugin-click", { plugin, objectIDs });
    },
    loadPluginList() {
      if (this.selectedDocuments.length > 0) {
        PluginService.getAuthorizedList(
          "ResultViewToolbar",
          this.selectedDocuments
        ).then((result) => {
          this.pluginList = result.map(function (dto) {
            return new Plugin(dto);
          });
        });
      } else {
        this.pluginList = [];
      }
    },
  },
};
</script>

<style>
.disabled-item {
  opacity: 0.5;
}
</style>
